import Vue from 'vue'
import Vuex from 'vuex'
import { Howl, Howler } from 'howler'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    numScenes: 8,
    currentScene: 1,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    hasToolBeenUsed: false,
    audio: {
      click: new Howl({
        src: ['audio/click.mp3'],
        html5: true
      }),
      blob: new Howl({
        src: ['audio/blob.mp3'],
        html5: true
      }),
      chisel: new Howl({
        src: ['audio/chisel-break.mp3'],
        html5: true
      }),
      string: new Howl({
        src: ['audio/string.mp3'],
        html5: true
      }),
      liquid: new Howl({
        src: ['audio/liquid.mp3'],
        html5: true
      })
    }
  },
  mutations: {
    SET_CURRENT_SCENE (state, payload) {
      state.currentScene = payload
    },
    PREVIOUS_SCENE (state) {
      state.currentScene--
    },
    NEXT_SCENE (state) {
      state.currentScene++
    },
    MUTE (state) {
      state.muted = true
    },
    UNMUTE (state) {
      state.muted = false
    },
    RESET_TRACK_TIME (state) {
      state.trackTime = 0
    },
    RESET_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.1
      }, 100)
    },
    CLEAR_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
    },
    USE_TOOL(state) {
      state.hasToolBeenUsed = true;
    }, 
    RESET_TOOL(state) {
      state.hasToolBeenUsed = false;
    }
  },
  actions: {
    previousScene ({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit('PREVIOUS_SCENE')
      }
      commit('RESET_TOOL');
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
      dispatch('playAudioByName', 'click');
    },
    nextScene({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit("NEXT_SCENE");
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      commit('RESET_TOOL');
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
      dispatch('playAudioByName', 'click');
    },
    toggleMute ({ state, commit }) {
      if (state.muted) {
        Howler.mute(false)
        commit('UNMUTE')
      } else {
        Howler.mute(true)
        commit('MUTE')
      }
    },
    stopAllAudio ({ state }) {
      Object.keys(state.audio).forEach((key) => {
        state.audio[key].stop()
      })
    },
    playAudioByName ({ state, dispatch }, name) {
      dispatch('stopAllAudio')
      if (typeof state.audio[name] !== 'undefined') {
        state.audio[name].play()
      }
    },
    toolDrop({ commit, dispatch }, sound) {
        commit('RESET_TRACK_INTERVAL')
        commit('RESET_TRACK_TIME')
        commit('USE_TOOL')
        dispatch('playAudioByName', sound)
    },
  }
})

export default store
